import { Injectable } from '@angular/core';
import { WebApiClient } from '../../web-api-client.service';
import { WebApiService } from '../../web-api.service';
import { StockDocumentChangePageResult, StockDocumentChangeQuery } from 'src/app/stocks/stock-change/models/stock-change';

/** 依扣庫規則排序的可用批（含現有量；前端做同單跨列扣減用）*/
export interface AvailableBatchItemDto {
  ProductBatchId: number;
  BatchNo: string;
  ExpirationDate: string | null;
  /** 該庫別此批可用量（帶 changeDate 時為單據日快照、否則為現在量；跨列扣減由前端計算）*/
  CurrentQty: number;
}

/** 一個子商品對應一組依規則排序的可用批 */
export interface ProductAvailableBatchesDto {
  ProductId: number;
  Batches: AvailableBatchItemDto[];
  /** 該商品該庫別「未指定批(溢流赤字池)」現有量，可能為負(赤字)；無未指定批時為 0 */
  UnassignedQty: number;
}

@Injectable({ providedIn: 'root' })
export class StockChangeApi {
  private apiService: WebApiService;

  constructor(private apiClient: WebApiClient) {
    this.apiService = this.apiClient.createHisService('Stocks/StockChange');
  }

  async GetAllStockDocumentChange(query: StockDocumentChangeQuery): Promise<StockDocumentChangePageResult> {
    return await this.apiService.get('GetAllStockDocumentChange', query).toPromise<StockDocumentChangePageResult>();
  }

  async GetFirstChangeDate(): Promise<Date | null> {
    return await this.apiService.get('GetFirstChangeDate').toPromise<Date | null>();
  }

  /**
   * 取依扣庫規則（FEFO/FIFO）排序的可用批（含現有量），一商品撈一次後前端快取重用，
   * 同單同商品多列的跨列扣減與預帶分配全在前端記憶體計算。
   * @param req.storeRoomId 庫別 ID
   * @param req.productIds 子商品 ID 清單（母/組由前端展開後送）
   */
  async getAvailableBatchesForAllocation(req: {
    storeRoomId: number;
    productIds: number[];
    /** 異動日（出庫排除過期批的基準日，同時決定可用量基準：帶=單據日快照、省略=現在量且不排除過期） */
    changeDate?: Date | string;
    /** true = 包含現有量 0 的批（調整作業調增用；預設 false 只列有量批） */
    includeZeroStock?: boolean;
    /** true = 包含仍有殘量的停用批（調整/盤點沖銷凍結殘量用；殘量歸零後即不再列出） */
    includeStopBatch?: boolean;
    /** true = 包含已過期批（退貨用——過期品退廠商為常見流程；量基準仍照 changeDate 取快照。預設 false 維持銷售行為） */
    includeExpired?: boolean;
  }, isShowLoader = true): Promise<ProductAvailableBatchesDto[]> {
    return await this.apiService.post('GetAvailableBatchesForAllocation', req, isShowLoader)
      .toPromise<ProductAvailableBatchesDto[]>();
  }
}
